import { QueryParametersState } from "@idw-types/state";
import fetch from "cross-fetch";

type StartCaptureProcessResponse = {
    status: string;
    errorMessage: string;
    responseToken: string;
};

export const startCaptureProcess = async (queryParameters: QueryParametersState): Promise<StartCaptureProcessResponse> => {   
    const route = `${queryParameters.apiUrl}/axn/doc/start?_cb=${new Date().getTime()}`;
    const request = {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ token: queryParameters.token }),
        method: "POST"
    };
    const response = await fetch(route, request);

    if (response) {
        const jsonResponse = await response.json();
        if (jsonResponse.status === "success") {
            return jsonResponse;
        } else {
            throw new Error(jsonResponse.errorMessage);
        }
    }

    throw new Error("Problem getting response");
};